// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:768px){.video-item-program-name--column{font-size:14px}.video-item-program-name--row{font-size:16px}}@media (min-width:1200px){.video-item-program-name--column-large{font-size:16px}}", ""]);
// Exports
module.exports = exports;
